import { ConfigService } from '../../../../config/shared/config.service';
import { CreditCardContactInfo } from '../../../../revenue/shared/credit-card/credit-card-contact-info.model';
import { CreditCardPaymentDto } from './dto/credit-card-payment.dto';
import { Component, OnInit, Input } from '@angular/core';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'wl-credit-card-payment',
  templateUrl: './credit-card-payment.component.html',
  styleUrls: ['./credit-card-payment.component.less'],
    standalone: false
})
export class CreditCardPaymentComponent implements OnInit {
  @Input() creditCardPayment: CreditCardPaymentDto;

  public months: SelectItem[];
  public years: SelectItem[];
  public cardTypes: SelectItem[];

  constructor(private _configService: ConfigService) {
    this.generateMonths();
    this.generateYears();
  }

  ngOnInit() {
    this._configService.getCreditCardTypes().then((data) => {
      this.cardTypes = [];
      data.forEach((card) => {
        this.cardTypes.push({
          label: card,
          value: card,
        });
      });
    });
  }

  private generateMonths() {
    this.months = [];
    for (let i = 1; i < 13; i++) {
      this.months.push({
        label: `${i}`,
        value: i,
      } as SelectItem);
    }
  }

  private generateYears() {
    const min = new Date().getFullYear();
    const max = min + 10;
    this.years = [];
    for (let i = min; i < max; i++) {
      this.years.push({
        label: `${i}`,
        value: i,
      } as SelectItem);
    }
  }
}
